import { CompassOutlined } from "@ant-design/icons";
import { ResourceProps } from "@refinedev/core";
import { nameLeagueMap } from "../Matches/Lib";

export const clubsResource: ResourceProps = {
  name: "clubs",
  meta: {
    icon: <CompassOutlined />,
    label: "Клубы",
  },
};

export const seasonsResourceClubsLeagueGenerator = (
  type: "first-league" | "second-league" | "third-league"
): ResourceProps => {
  return {
    name: `${type}`,
    list: `/clubs/${type}`,
    show: `/clubs/${type}/show/:id`,
    create: `/clubs/${type}/create`,
    edit: `/clubs/${type}/edit/:id`,
    meta: {
      parent: "clubs",
      label: nameLeagueMap[type],
    },
  };
};
